export default __webpack_public_path__ + "static/media/favouriteFilled.10a396c7.svg";